import { render } from "./Oauth2Callback.vue?vue&type=template&id=16c21059"
import script from "./Oauth2Callback.vue?vue&type=script&lang=js"
export * from "./Oauth2Callback.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__